"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const daLocaleData = require("i18next-icu/locale-data/da");
exports.default = daLocaleData;
//# sourceMappingURL=da.js.map